// extracted by mini-css-extract-plugin
module.exports = {"comp":"ListA_comp__bEBok"};